import { render, staticRenderFns } from "./AddTabParentAccount.vue?vue&type=template&id=b5ccd6dc"
import script from "./AddTabParentAccount.vue?vue&type=script&lang=js"
export * from "./AddTabParentAccount.vue?vue&type=script&lang=js"
import style0 from "./AddTabParentAccount.vue?vue&type=style&index=0&id=b5ccd6dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports